ck.setCookie = function(cname, cvalue, exdays) {
  var expires = '', cookieString="";
  //if no exdays, expire with session
  if(typeof exdays === 'number')  {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000)); //set for specifed time
    expires = 'expires='+d.toUTCString();
  }
  document.cookie = (cname + '=' + cvalue + '; ' + expires +'; path=/');
};

ck.getCookie = function(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
};
